export { default } from './requests-collapse-header';
